import { z } from 'zod';
import { alterCode } from '../alterCodes/getAlterCodesWithConditions';

const groupItemAlterCode = z.object({
  id: z.string(),
  isActive: z.boolean(),
  isFromManager: z.boolean().optional(),
  groupItemId: z.string(),
  deleted: z.boolean().optional(),
  alterCode: alterCode,
});

export const getGroupItemsAlterCodeForGroupItemIdSchema = z.array(groupItemAlterCode);

export type GetGroupItemsAlterCodeForGroupItemIdResponse = z.infer<
  typeof getGroupItemsAlterCodeForGroupItemIdSchema
>;
